<template>
  <v-dialog v-model="openTranDetail" width="600" persistent>
    <v-card>
      <v-card-title class="headline colorHeadlineStandard" primary-title>
        {{ $t('label.detail') }}
        <v-spacer />
        <v-icon large @click="openTranDetail = false">{{ mdiClose }}</v-icon>
      </v-card-title>
      <v-card-text>
        <v-sheet class="pt-4" height="200">
          <v-row>
            <v-col>
              <div class="mt-1 ml-4">
                <v-row>
                  <v-col class="pb-0">{{ $t('label.iwpRecord') }}</v-col>
                </v-row>
              </div>
              <div v-if="childTran.parent === null" class="mt-2 ml-4">
                <v-row>
                  <v-col cols="3" class="pb-0">
                    <b>{{ $tc('label.area', 1) }}:</b>
                  </v-col>
                  <v-col cols="4" class="pb-0">
                    {{ areaName }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0">
                    <b>{{ $t('label.iwpNoRecord') }}:</b>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="mt-2 ml-4">
                <v-row>
                  <v-col cols="3" class="pb-0">
                    <b>{{ $tc('label.area', 1) }}:</b>
                  </v-col>
                  <v-col cols="4" class="pb-0">
                    {{ areaName }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="py-0">
                    <b>{{ $t('label.enter') }}:</b>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    {{ formatDate(childTran.timeenter, $store.state.auth.df.dateTime) }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="py-0">
                    <b>{{ $t('label.exit') }}:</b>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    {{ formatDate(childTran.timeexit, $store.state.auth.df.dateTime) }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { mdiClose } from '@mdi/js';
import { DefaultComputed } from 'vue/types/options';
import axios from 'axios';

export default Vue.extend({
  name: 'ArchiveTransactionDetail',
  props: {
    tranUUID: String,
    areaName: String,
    dialogTranDetail: Boolean,
  },
  data: () => ({
    childTran: {} as any,
    mdiClose: mdiClose,
  }),
  computed: {
    openTranDetail: {
      get() {
        this.getChildRow();
        return this.dialogTranDetail;
      },
      set(val: Boolean) {
        this.$emit('dialogTranDetail', val);
      },
    } as DefaultComputed,
  },

  methods: {
    formatDate(date: string, format: string) {
      if (date === null || date === '') {
        return '';
      }
      return this.$moment(date).format(format);
    },
    getChildRow() {
      if (this.tranUUID === '' || this.tranUUID === undefined) {
        return;
      }
      axios
        .get(`/api/v1/archivechild/${this.tranUUID}`)
        .then((response) => {
          this.childTran = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
